
export default function FactoryRequirementsSection() {
  const basicRequirements = [
    {
      category: '资质要求',
      items: [
        { label: '生产许可证', value: '食品生产许可证', icon: 'ri-certificate-line' },
        { label: '质量体系', value: 'ISO9001认证', icon: 'ri-award-line' },
        { label: '环保资质', value: '环保达标证明', icon: 'ri-leaf-line' },
        { label: '卫生许可', value: '卫生许可证', icon: 'ri-health-book-line' }
      ]
    },
    {
      category: '生产能力',
      items: [
        { label: '年产能', value: '100吨以上', icon: 'ri-scales-line' },
        { label: '生产线', value: '2条以上', icon: 'ri-settings-line' },
        { label: '仓储面积', value: '1000㎡以上', icon: 'ri-building-2-line' },
        { label: '员工数量', value: '50人以上', icon: 'ri-team-line' }
      ]
    },
    {
      category: '技术水平',
      items: [
        { label: '生产经验', value: '5年以上', icon: 'ri-time-line' },
        { label: '技术人员', value: '10人以上', icon: 'ri-user-star-line' },
        { label: '质检设备', value: '完善齐全', icon: 'ri-test-tube-line' },
        { label: '工艺标准', value: '标准化操作', icon: 'ri-file-list-line' }
      ]
    }
  ];

  const cooperationLevels = [
    {
      level: '初级合作伙伴',
      tier: '入门级',
      requirements: [
        '年产能100-500吨',
        '生产经验3年以上',
        '基础质量管理体系',
        '环保达标生产'
      ],
      benefits: [
        '订单保障支持',
        '技术指导服务',
        '质量管理培训',
        '市场信息分享'
      ],
      color: 'from-blue-500 to-blue-600',
      icon: 'ri-plant-line',
      minOrder: '月订单量：10-50吨'
    },
    {
      level: '优质合作伙伴',
      tier: '进阶级',
      requirements: [
        '年产能500-1000吨',
        '生产经验5年以上',
        'ISO质量认证',
        '自主研发能力'
      ],
      benefits: [
        '长期合同保障',
        '设备升级支持',
        '新品开发合作',
        '品牌授权使用'
      ],
      color: 'from-blue-500 to-blue-600',
      icon: 'ri-star-line',
      minOrder: '月订单量：50-100吨'
    },
    {
      level: '战略合作伙伴',
      tier: '专家级',
      requirements: [
        '年产能1000吨以上',
        '生产经验10年以上',
        '完善质量体系',
        '强大研发实力'
      ],
      benefits: [
        '股权投资机会',
        '技术深度合作',
        '品牌共同开发',
        '国际市场拓展'
      ],
      color: 'from-blue-500 to-blue-600',
      icon: 'ri-vip-crown-line',
      minOrder: '月订单量：100吨以上'
    }
  ];

  return (
    <section id="requirements" className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="container mx-auto px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            合作要求
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            我们欢迎不同规模的优质工厂加入，提供差异化的合作政策
          </p>
        </div>

        {/* Basic Requirements */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {basicRequirements.map((category, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-lg">
              <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-6 text-center">
                {category.category}
              </h3>
              <div className="space-y-4">
                {category.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div className="flex items-center">
                      <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                        <i className={`${item.icon} text-blue-600`}></i>
                      </div>
                      <span className="text-gray-700 font-medium text-sm md:text-base">{item.label}</span>
                    </div>
                    <span className="text-blue-600 font-semibold text-xs md:text-sm">{item.value}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Cooperation Levels */}
        <div className="mb-12">
          <h3 className="text-xl md:text-2xl font-bold text-center text-gray-800 mb-8">合作伙伴等级</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {cooperationLevels.map((level, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group hover:transform hover:scale-105"
              >
                <div className={`h-2 bg-gradient-to-r ${level.color}`}></div>
                <div className="p-6">
                  <div className="text-center mb-6">
                    <div className={`w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-r ${level.color} flex items-center justify-center`}>
                      <i className={`${level.icon} text-white text-2xl`}></i>
                    </div>
                    <h4 className="text-lg md:text-xl font-bold text-gray-800 mb-1">{level.level}</h4>
                    <p className="text-gray-500 mb-2 text-sm md:text-base">{level.tier}</p>
                    <div className={`text-xs md:text-sm font-semibold bg-gradient-to-r ${level.color} bg-clip-text text-transparent`}>
                      {level.minOrder}
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <div>
                      <h5 className="font-semibold text-gray-800 mb-2 text-sm md:text-base">申请条件</h5>
                      <div className="space-y-1">
                        {level.requirements.map((req, reqIndex) => (
                          <div key={reqIndex} className="flex items-center text-xs md:text-sm text-gray-600">
                            <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></div>
                            {req}
                          </div>
                        ))}
                      </div>
                    </div>
                    
                    <div>
                      <h5 className="font-semibold text-gray-800 mb-2 text-sm md:text-base">合作优势</h5>
                      <div className="space-y-1">
                        {level.benefits.map((benefit, benefitIndex) => (
                          <div key={benefitIndex} className="flex items-center text-xs md:text-sm text-gray-600">
                            <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></div>
                            {benefit}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Quality Standards */}
        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-xl md:text-2xl font-bold text-center text-gray-800 mb-8">
            质量标准要求
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
                <i className="ri-leaf-line text-blue-600 text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-800 mb-3 text-base md:text-lg">原料标准</h4>
              <div className="space-y-2">
                <div className="text-xs md:text-sm text-gray-600">有机茶园认证</div>
                <div className="text-xs md:text-sm text-gray-600">农残检测合格</div>
                <div className="text-xs md:text-sm text-gray-600">重金属含量达标</div>
                <div className="text-xs md:text-sm text-gray-600">感官品质优良</div>
              </div>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
                <i className="ri-settings-line text-blue-600 text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-800 mb-3 text-base md:text-lg">生产标准</h4>
              <div className="space-y-2">
                <div className="text-xs md:text-sm text-gray-600">GMP标准厂房</div>
                <div className="text-xs md:text-sm text-gray-600">无菌化操作</div>
                <div className="text-xs md:text-sm text-gray-600">温湿度控制</div>
                <div className="text-xs md:text-sm text-gray-600">全程可追溯</div>
              </div>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
                <i className="ri-box-line text-blue-600 text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-800 mb-3 text-base md:text-lg">包装标准</h4>
              <div className="space-y-2">
                <div className="text-xs md:text-sm text-gray-600">食品级包材</div>
                <div className="text-xs md:text-sm text-gray-600">密封性良好</div>
                <div className="text-xs md:text-sm text-gray-600">标识规范完整</div>
                <div className="text-xs md:text-sm text-gray-600">保质期管理</div>
              </div>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
                <i className="ri-test-tube-line text-blue-600 text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-800 mb-3 text-base md:text-lg">检测标准</h4>
              <div className="space-y-2">
                <div className="text-xs md:text-sm text-gray-600">第三方检测</div>
                <div className="text-xs md:text-sm text-gray-600">批批检验</div>
                <div className="text-xs md:text-sm text-gray-600">留样管理</div>
                <div className="text-xs md:text-sm text-gray-600">质量档案</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
